import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const ResendButton = ({ email, className = "" }) => {
  const [loading, setLoading] = useState(false);
  const resend = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/resend-verification", { email });
      toast.success(data.message);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button type="button" variant="outline" onClick={resend} disabled={loading} className={`h-12 rounded-full border-[#0F2D5E] text-[#0F2D5E] ${className}`} data-testid="resend-verification-btn">
      {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Reinvia email di conferma
    </Button>
  );
};

export const CheckEmail = ({ email }) => (
  <div className="text-center" data-testid="check-email-panel">
    <span className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-[#0F2D5E] text-[#F4C20D]"><MailCheck className="h-8 w-8" /></span>
    <h2 className="mt-6 text-2xl font-extrabold">Controlla la tua email</h2>
    <p className="mt-3 text-[#495850]">
      Abbiamo inviato un link di conferma a <strong className="break-all text-[#0F2D5E]" data-testid="check-email-address">{email}</strong>.
      Cliccalo per attivare l'account e accedere. Se non la trovi, guarda anche nello spam.
    </p>
    <div className="mt-8 flex flex-col gap-3">
      <ResendButton email={email} />
      <Button asChild className="h-12 rounded-full bg-[#0F2D5E] hover:bg-[#0B2250]" data-testid="check-email-login-btn"><Link to="/accedi">Vai al login</Link></Button>
    </div>
  </div>
);
